import { inject } from 'vue'

export function useProductApi() {
  const API_DOMAIN_PRODUCT = inject('CURAPICK_API_DOMAIN_PRODUCT')

  /** METHODS */
  const fetchProducts = async (filterValue) => {
    const apiLink = new URL('/api/product/phm', API_DOMAIN_PRODUCT)
    apiLink.searchParams.set('filterBy', 'sku')
    apiLink.searchParams.set('filterValue', filterValue)

    return await fetch(apiLink)
  }

  return { fetchProducts }
}
